export default __webpack_public_path__ + "static/media/contract.d2af6c95.svg";